import { Label } from '@/components/ui/label';

export default function RadioQuestion({ label, value, options, onChange, testIdPrefix, error }) {
  return (
    <div>
      <Label className="mb-3 block">{label}</Label>
      <div className="space-y-2">
        {options.map((option) => {
          const optVal = typeof option === 'string' ? option : option.value;
          const optLabel = typeof option === 'string' ? option : option.label;
          return (
            <div
              key={optVal}
              onClick={() => onChange(optVal)}
              className={`flex items-center space-x-3 p-3 border rounded-md cursor-pointer transition-all ${
                value === optVal ? 'border-primary bg-primary/5 ring-1 ring-primary/20' : 'hover:bg-muted'
              } ${error ? 'border-destructive/50' : ''}`}
              data-testid={`${testIdPrefix}-${optVal.toLowerCase().replace(/[\s/]+/g, '-')}`}
            >
              <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${
                value === optVal ? 'border-primary' : 'border-muted-foreground/40'
              }`}>
                {value === optVal && <div className="w-2 h-2 rounded-full bg-primary" />}
              </div>
              <span className="text-sm flex-1">{optLabel}</span>
            </div>
          );
        })}
      </div>
      {error && <p className="text-xs text-destructive mt-1">{error}</p>}
    </div>
  );
}
